import { render, staticRenderFns } from "./FooterVi.vue?vue&type=template&id=f347a0ae&scoped=true&"
import script from "./FooterVi.vue?vue&type=script&lang=js&"
export * from "./FooterVi.vue?vue&type=script&lang=js&"
import style0 from "./FooterVi.vue?vue&type=style&index=0&id=f347a0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f347a0ae",
  null
  
)

export default component.exports